export default __webpack_public_path__ + "static/media/tw.3e792238.svg";